import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import quizAllBanner from "../../../../styles/img/quiz-all-banner.png";
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import KnowledgeInnerBanner from "./Views/KnowledgeInnerBanner";
import { UiContentCol, UiContentWr } from "../../components/common/UiPageElements";
import { UiRowContainer } from "../../components/grid-container/GridContainer";
import { QuizzerCard } from "./Views/QuizzerCard";
import ToyotaLogo from '../../../../styles/img/toyotalogo.png';
import Footer from "../../components/footer/Footer";
import ToyotaInnerBanner from '../../../../styles/img/knowledge-inner-quiz.png'

export const QuizzersAll = () => {
    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBanner
                    title="Learning History"
                    description="See what courses you’ve completed!"
                    innerBanner={ToyotaInnerBanner}
                    className="sb-knowldg-inner-banner"  /> 
 

                 <UiBannerBottomBar
                     prevPage="Knowledge"
                prevPageLink="/ui"
                currentPage="  Learning History"
                currentPageLink="/ui/incentives-pre-register" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-quizzers-all-sec">
                        <UiContentCol>
                            <div className="sb-quizzers-all-sec__nav">
                                <div className="sb-quizzers-all-sec-nav-link active"> All Quizzes </div>
                                <div className="sb-quizzers-all-sec-nav-link"> Completed </div>
                            </div>

                            <QuizzerCard
                                status="in-progress"
                                title="Quiz Name"
                                image={ToyotaLogo}
                                description="Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum, Lorem epsum to start badge priority lorem epsum Lorem epsum to"
                            />

                            <QuizzerCard
                                status="completed"
                                title="Quiz Name"
                                image={ToyotaLogo}
                                description="Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum, Lorem epsum to start badge priority lorem epsum Lorem epsum to"
                            />

                            <QuizzerCard
                                status="completed"
                                title="Quiz Name"
                                image={ToyotaLogo}
                                description="Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum, Lorem epsum to start badge priority lorem epsum Lorem epsum to"
                            />

                            <QuizzerCard
                                status="in-progress"
                                title="Quiz Name"
                                image={ToyotaLogo}
                                description="Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum, Lorem epsum to start badge priority lorem epsum Lorem epsum to"
                            />

                            <QuizzerCard
                                status="not-started"
                                title="Quiz Name"
                                image={ToyotaLogo}
                                description="Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum, Lorem epsum to start badge priority lorem epsum Lorem epsum to"
                            />

                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <Footer />
                
            </UiMainWrapper>
            

            </>
            )
}